import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KmpmasterService {

  constructor(private http: HttpClient, private httpService: HttpService) { }
        addKmp(newKmp) {
                var request = {
                        URL: "kmpMaster/addKmp",
                        DATA: newKmp
                }
                return this.httpService.post(request);
                // var headers = new Headers();
                // headers.append('Content-Type', 'application/json');
                // return this.http.post(environment.pssServerUrl + 'kmpMaster/addKmp', JSON.stringify(newKmp), { headers: headers })
                //         .map(res => res.json());
        }

        getMasterKmp(dateModel) {

                var request = {
                        URL: "kmpMaster/filterKMPMasterByDate/null",
                        DATA: dateModel
                }
                return this.httpService.post(request);
                // return this.http.get(environment.pssServerUrl + 'kmpMaster/5a5b43bd3202413a5c81636f', )
                //         .map(res => res.json());
        }

        getKmpDetails(kmpId: string) {
                var headers = new HttpHeaders();
                headers.append('Content-Type', 'application/json');
                var token = localStorage.getItem('token')
                headers.append("x-access-token", token)
                return this.http.get(environment.pssServerUrl + 'kmpMaster/getKmpDetails/' + kmpId,{headers:headers})
                        .map(res => res);
        }

        removeKmpship(kmpshipId: string) {
                var headers = new HttpHeaders();
                headers.append('Content-Type', 'application/json');
                var token = localStorage.getItem('token')
                headers.append("x-access-token", token)
                return this.http.post(environment.pssServerUrl + 'kmpMaster/removeKmpship/' + kmpshipId,null, {headers:headers})
                        .map(res => res);
        }

        removeSubKmp(subkmpId: string) {
                var headers = new HttpHeaders();
                headers.append('Content-Type', 'application/json');
                var token = localStorage.getItem('token')
                headers.append("x-access-token", token)
                return this.http.post(environment.pssServerUrl + 'kmpMaster/removeSubKmp/' + subkmpId,null, {headers:headers})
                        .map(res => res);
        }

        getRegisterKmp() {
                var request = {
                        URL: "kmpMaster/getRegisterKmp/522b2649b2e70464f113c04d"
                }
                return this.httpService.get(request);

                // return this.http.get(environment.pssServerUrl + 'kmpMaster/getRegisterKmp/522b2649b2e70464f113c04d', )
                //         .map(res => res.json());
        }

        addRelatives(newRelative) {
                var headers = new HttpHeaders();
                headers.append('Content-Type', 'application/json');
                var token = localStorage.getItem('token')
                headers.append("x-access-token", token)
                return this.http.post(environment.pssServerUrl + 'kmpMaster/addRelatives', JSON.stringify(newRelative), { headers: headers })
                        .map(res => res);
        }

        getRelativesDetails(KmpPAN: string) {
                var headers = new HttpHeaders();
                headers.append('Content-Type', 'application/json');
                var token = localStorage.getItem('token')
                headers.append("x-access-token", token)
                return this.http.get(environment.pssServerUrl + 'kmpMaster/getRelatives/' + KmpPAN,{headers:headers})
                        .map(res => res);
        }

        removeRelative(relativeId: string) {
                var headers = new HttpHeaders();
                headers.append('Content-Type', 'application/json');
                var token = localStorage.getItem('token')
                headers.append("x-access-token", token)
                return this.http.post(environment.pssServerUrl + 'kmpMaster/removeRelatives/' + relativeId,null, {headers:headers})
                        .map(res => res);
        }

        getUnauthorizeKmpshipSubKmp(kmpId: String) {
                var headers = new HttpHeaders();
                headers.append('Content-Type', 'application/json');
                var token = localStorage.getItem('token')
                headers.append("x-access-token", token)
                return this.http.get(environment.pssServerUrl + 'kmpMaster/Unauthorized/' + kmpId,{headers:headers})
                        .map(res => res);
        }

        getUnRectifiedKmpshipSubkmp(kmpId: String) {
                var headers = new HttpHeaders();
                headers.append('Content-Type', 'application/json');
                var token = localStorage.getItem('token')
                headers.append("x-access-token", token)
                return this.http.get(environment.pssServerUrl + 'kmpMaster/UnRectified/' + kmpId,{headers:headers})
                        .map(res => res);
        }

        authorize(authorizeKmpSubkmp) {
                var headers = new HttpHeaders();
                headers.append('Content-Type', 'application/json');
                var token = localStorage.getItem('token')
                headers.append("x-access-token", token)
                return this.http.post(environment.pssServerUrl + 'kmpMaster/getAuthorize', authorizeKmpSubkmp,{headers:headers})
                        .map(res => res);
        }


        rectify(rectifyKmpSubkmp) {
                var headers = new HttpHeaders();
                headers.append('Content-Type', 'application/json');
                var token = localStorage.getItem('token')
                headers.append("x-access-token", token)
                return this.http.post(environment.pssServerUrl + 'kmpMaster/getRectify', rectifyKmpSubkmp,{headers:headers})
                        .map(res => res);
        }

        getKMPshipByDate(dateModel) {
                var request = {
                        URL: "kmpship/filterkmpshipbydate",
                        DATA: dateModel
                }
                return this.httpService.post(request);
        }

        getKMPship(dateModel): Promise<any> {

                var headers = new HttpHeaders();
                headers.append('Content-Type', 'application/json');
                var token = localStorage.getItem('token')
                headers.append("x-access-token", token)

                var request = {
                        URL: "kmpship/filterkmpshipbydate",
                        DATA: dateModel
                }
                return this.http.post(environment.pssServerUrl + request.URL, request.DATA,{headers:headers}).toPromise()
                        .then(response => {
                                return Promise.resolve(response);
                        })
        }

        getSubKMPByDate(dateModel) {
                var request = {
                        URL: "subkmp/filtersubkmpbydate",
                        DATA: dateModel
                }
                return this.httpService.post(request);
        }

        getSubKMP(dateModel): Promise<any> {
                var headers = new HttpHeaders();
                headers.append('Content-Type', 'application/json');
                var token = localStorage.getItem('token')
                headers.append("x-access-token", token)

                var request = {
                        URL: "subkmp/filtersubkmpbydate",
                        DATA: dateModel
                }
                return this.http.post(environment.pssServerUrl + request.URL, request.DATA,{headers:headers}).toPromise()
                        .then(response => {
                                return Promise.resolve(response);
                        })
        }

        getRelativeByDate(dateModel) {
                var request = {
                        URL: "relative/filterrelativebydate",
                        DATA: dateModel
                }
                return this.httpService.post(request);
        }

        getRelative(dateModel): Promise<any> {


                var headers = new HttpHeaders();
                headers.append('Content-Type', 'application/json');
                var token = localStorage.getItem('token')
                headers.append("x-access-token", token)


                var request = {
                        URL: "relative/filterrelativebydate",
                        DATA: dateModel
                }
                return this.http.post(environment.pssServerUrl + request.URL, request.DATA,{headers:headers}).toPromise()
                        .then(response => {
                                return Promise.resolve(response);
                        })
        }

        getDirectorsByDesignation(designation) {
                var request = {
                        URL: "director/directorbyDesignation/" + designation,                       
                }
                return this.httpService.post(request);
        }

        addThisKMPAsDirector(KMPId){
                var KMPData={
                        id : KMPId
                }
                var request = {
                        URL: "register/addThisKMPAsDirector",
                        DATA: KMPData
                }
                return this.httpService.post(request);
        }

        generateKmpDocument(object) {
                var request = {
                    URL: "kmp/generateKmpDocument",
                    DATA: object
                }
                return this.httpService.post(request);
            }
        
            downloadKmpFile(id) {
                var token = localStorage.getItem('token')
                window.location.href = environment.pssServerUrl + "kmp/downloadDocument/" + id + "/" + token;
            }
            downloadKmpPdfDocument(id) {
                var token = localStorage.getItem('token')
                window.location.href = environment.pssServerUrl + "kmp/downloadPdfDocument/" + id + "/" + token;
            }
        
}